import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import axios from "./axiosConfig";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


// Públicas
import HomeTikpontos from "./pages/HomeTikpontos";
import Login from "./pages/Login";
import CadastroCliente from "./pages/CadastroCliente";
import EsqueciSenha from "./pages/EsqueciSenha";
import RedefinirSenha from "./pages/RedefinirSenha";
import SorteioLeadPublico from "./pages/SorteioLeadPublico";

import SorteadorLogin from "./pages/SorteadorLogin";
import SorteadorAoVivo from "./pages/SorteadorAoVivo";

// Header Admin
import Header from "./components/Header";

// Cliente
import PainelCliente from "./pages/PainelCliente/PainelCliente";
import PainelClienteHome from "./pages/PainelCliente/PainelClienteHome";
import MeusResgates from "./pages/PainelCliente/MeusResgates";
import MeusPontos from "./pages/PainelCliente/MeusPontos";
import CatalogoPremios from "./pages/PainelCliente/CatalogoPremios";
import CampanhaInscricao from "./pages/CampanhaInscricao";
import MinhasCampanhas from "./pages/PainelCliente/MinhasCampanhas";
import CarrinhoResgates from "./pages/PainelCliente/CarrinhoResgates";

import RegrasPrograma from "./pages/PainelCliente/RegrasPrograma";

import CadastrarOperacao from "./pages/PainelCliente/CadastrarOperacao";
import ResgatarPremio from "./pages/PainelCliente/ResgatarPremio";
import MeuPerfil from "./pages/PainelCliente/MeuPerfil";




import GruposEmpresariais from "./pages/GruposEmpresariais";


// Eventos (clientes)
import EventoCadastroPage from "./pages/eventos/clientes/EventoCadastroPage";
import PainelEventoCliente from "./pages/eventos/clientes/painel/PainelEventoCliente";
import ResultadoEventoPage from "./pages/eventos/clientes/premio/ResultadoEventoPage";
import ListaEventosCliente from "./pages/eventos/clientes/painel/ListaEventosCliente";

// Eventos (admin)
import ListarEventosPage from "./pages/eventos/admin/ListarEventosPage";
import CriarEventoPage from "./pages/eventos/admin/CriarEventoPage";
import EditarEventoPage from "./pages/eventos/admin/EditarEventoPage";
import SorteiosAdminEventoPage from "./pages/eventos/admin/SorteiosAdminEventoPage";
import PainelTodosSorteiosPage from "./pages/eventos/admin/PainelTodosSorteiosPage";

//Tikpag Experience
import TikpagExperienceDashboard from "./pages/TikpagExperience/TikpagExperienceDashboard";
import TikpagExperienceCampanhas from "./pages/TikpagExperience/TikpagExperienceCampanhas";
import TikpagExperiencePins from "./pages/TikpagExperience/TikpagExperiencePins";
import TikpagExperienceCategorias from "./pages/TikpagExperience/TikpagExperienceCategorias";
import TikpagExperienceExperiencias from "./pages/TikpagExperience/TikpagExperienceExperiencias";
import TikpagExperienceApuracoes from "./pages/TikpagExperience/TikpagExperienceApuracoes";
import TikpagExperienceParticipantes from "./pages/TikpagExperience/TikpagExperienceParticipantes";
import TikpagExperienceEscolhas from "./pages/TikpagExperience/TikpagExperienceEscolhas";
import TikpagExperiencePinsEntregas from "./pages/TikpagExperience/TikpagExperiencePinsEntregas";
import TikpagExperienceRelatorios from "./pages/TikpagExperience/TikpagExperienceRelatorios";
import TikpagExperienceAuditoria from "./pages/TikpagExperience/TikpagExperienceAuditoria";

import TikpagExperienceCliente from "./pages/PainelCliente/TikpagExperienceCliente";
import TikpagExperienceEscolha from "./pages/PainelCliente/TikpagExperienceEscolha";
import TikpagExperienceVitrine from "./pages/PainelCliente/TikpagExperienceVitrine";




// Admin geral
import Dashboard from "./pages/Dashboard";
import Usuarios from "./pages/Usuarios";
import Operacoes from "./pages/Operacoes";
import Resgates from "./pages/Resgates";
import Premios from "./pages/Premios";
import CadastrarPremio from "./pages/CadastrarPremio";
import EditarUsuario from "./pages/EditarUsuario";
import NovoUsuario from "./pages/NovoUsuario";
import EditarPremio from "./pages/EditarPremio";
import CreditoManualPontos from "./pages/CreditoManualPontos";
import HistoricoPontos from "./pages/HistoricoPontos";
import RelatorioPontos from "./pages/RelatorioPontos";
import Clientes from "./pages/Clientes";
import NovoCliente from "./pages/NovoCliente";
import EditarCliente from "./pages/EditarCliente";
import PerfisCliente from "./pages/PerfisCliente";
import PainelCampanhas from "./pages/PainelCampanhas";
import EditarCampanha from "./pages/EditarCampanha";
import Expedicao from "./pages/Expedicao";
import InscritosCampanha from "./pages/InscritosCampanha";
import InscritosTodasCampanhas from "./pages/InscritosTodasCampanhas";
import Empresas from "./pages/Empresas";
import NovaEmpresa from "./pages/NovaEmpresa";
import EditarEmpresa from "./pages/EditarEmpresa";
import PreviewEmpresasCSV from "./pages/PreviewEmpresasCSV";

import ConfiguracoesValorPonto from "./pages/ConfiguracoesValorPonto";
import PermissoesUsuario from "./pages/PermissoesUsuario";
import LogsRecaptcha from "./pages/LogsRecaptcha";
import ConfiguracaoFrete from "./pages/ConfiguracaoFrete"; 
import FaqBot from "./pages/FaqBot";
import ImportarOperacaoTikpag from "./pages/ImportarOperacaoTikpag";
import ImportarPixTikpag from "./pages/ImportarPixTikpag";
import ResgatesManuais from "./pages/ResgatesManuais";
import SorteioLeadsAdmin from "./pages/SorteioLeadsAdmin";
import CategoriasPremios from "./pages/CategoriasPremios";

import SorteiosLeadsLista from "./pages/SorteiosLeadsLista";
import SorteioLeadForm from "./pages/SorteioLeadForm";
import SorteioQRCodePage from "./pages/SorteioQRCodePage";

import LiberarPedido from "./pages/LiberarPedidoPage";

import TikpagBI from "./pages/TikpagBI";

import TikpagDiagnostico from "./pages/TikpagDiagnostico";

import TikpagBIImobiliaria from "./pages/TikpagBIImobiliaria";

import MonitoramentoAdmin from "./pages/MonitoramentoAdmin";

import TikpagBICrescimento from "./pages/TikpagBICrescimento";
import TikpagBIQueda from "./pages/TikpagBIQueda";

//PIX

import PixClientePage from "./pages/PainelCliente/PixClientePage";
import PixAdminPage from "./pages/PixAdminPage";
import PixContasAPagarPage from "./pages/PixContasAPagarPage";

//BANNER

import BannerHomePage from "./pages/BannerHomePage";


function AppRouter() {
  const [usuario, setUsuario] = useState(null);
  const [loadingUsuario, setLoadingUsuario] = useState(true);
  const location = useLocation();

  useEffect(() => {
    let stored = null;
    try {
      stored = JSON.parse(localStorage.getItem("usuario"));
    } catch (e) {
      console.warn("Erro ao ler usuario do localStorage:", e);
      localStorage.removeItem("usuario");
    }
    const token = localStorage.getItem("token");
    if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUsuario(stored || null);
    setLoadingUsuario(false);
  }, [location.pathname]);

  const tipoAdmin = ["admin", "financeiro", "comercial", "logistica"].includes(usuario?.tipo);

  const rotaPublicaSemHeader =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/cadastro" ||
    location.pathname === "/esqueci-senha" ||
    location.pathname.startsWith("/redefinir-senha/") ||
    location.pathname.startsWith("/sorteios/") ||
    location.pathname === "/sorteador-login" ||
    location.pathname.startsWith("/sorteador/") ||
    location.pathname.startsWith("/eventos/");

  if (loadingUsuario) {
    return <div style={{ padding: "2rem", textAlign: "center" }}>Carregando...</div>;
  }

  return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={3000}
        />

        {usuario &&
            tipoAdmin &&
            !rotaPublicaSemHeader && (
              <Header />
            )}

        <Routes>
        {/* Públicas */}
        <Route path="/" element={<HomeTikpontos />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<CadastroCliente />} />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/redefinir-senha/:token" element={<RedefinirSenha />} />
        <Route path="/empresas" element={<Empresas />} />
        <Route path="/empresas/nova" element={<NovaEmpresa />} />
        <Route path="/empresas/editar/:id" element={<EditarEmpresa />} />
        <Route path="/empresas/importar" element={<PreviewEmpresasCSV />} />
        
        <Route path="/sorteios/:slug" element={<SorteioLeadPublico />} />

        <Route path="/sorteador-login" element={<SorteadorLogin />} />
        <Route path="/sorteador/:slug/ao-vivo" element={<SorteadorAoVivo />} />

        {/* Eventos cliente */}
        <Route path="/eventos/:slug" element={<EventoCadastroPage />} />
        <Route path="/eventos/painel/:slug" element={<PainelEventoCliente />} />
        <Route path="/eventos/premio/:slug" element={<ResultadoEventoPage />} />

        {/* Cliente logado */}
         <Route
              path="/painel-cliente/*"

              element={
                usuario?.tipo === "cliente"
                  ? <PainelCliente />
                  : <Navigate to="/login" replace />
              }
            >
          <Route index element={<PainelClienteHome />} />
          <Route path="meus-resgates" element={<MeusResgates />} />
          <Route path="meus-pontos" element={<MeusPontos />} />
          <Route path="catalogo-premios" element={<CatalogoPremios />} />
          <Route path="cadastrar-operacao" element={<CadastrarOperacao />} />
          <Route path="resgatar/:id" element={<ResgatarPremio />} />
          <Route path="campanhas/:id/inscricao" element={<CampanhaInscricao />} />
          <Route path="minhas-campanhas" element={<MinhasCampanhas />} />

          <Route
            path="tikpag-experience"
            element={<TikpagExperienceCliente />}
          />

          <Route
            path="tikpag-experience/experiencias"
            element={<TikpagExperienceVitrine />}
          />

          <Route
            path="tikpag-experience/conquistas/:conquistaId/escolher"
            element={<TikpagExperienceEscolha />}
          />

          <Route path="carrinho-resgates" element={<CarrinhoResgates />} />
          
          <Route path="regras" element={<RegrasPrograma />} />
          
          
          <Route path="eventos" element={<ListaEventosCliente />} />
          <Route path="pix" element={<PixClientePage />} />

          <Route path="perfil" element={<MeuPerfil />} />

        </Route>

        {/* Admin */}
        {tipoAdmin && (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
                path="/admin/monitoramento"
                element={<MonitoramentoAdmin />}
              />
            <Route path="/usuarios" element={<Usuarios />} />
            <Route path="/usuarios/novo" element={<NovoUsuario />} />
            <Route path="/usuarios/editar/:id" element={<EditarUsuario />} />
            <Route path="/clientes" element={<Clientes />} />
            <Route path="/clientes/novo" element={<NovoCliente />} />
            <Route path="/clientes/editar/:id" element={<EditarCliente />} />
            <Route path="/operacoes" element={<Operacoes />} />
            <Route path="/liberar-pedido" element={<LiberarPedido />} />
            <Route path="/resgates" element={<Resgates />} />

            <Route
              path="/admin/grupos-empresariais"
              element={<GruposEmpresariais />}
            />

            <Route path="/resgates/manuais" element={<ResgatesManuais />} />

            <Route path="/premios" element={<Premios />} />
            <Route path="/premios/cadastrar" element={<CadastrarPremio />} />
            <Route path="/editar-premio/:id" element={<EditarPremio />} />
            <Route path="/creditar-pontos" element={<CreditoManualPontos />} />
            <Route path="/historico-pontos" element={<HistoricoPontos />} />
            <Route path="/relatorio-pontos" element={<RelatorioPontos />} />
            <Route path="/perfis-cliente" element={<PerfisCliente />} />
            <Route path="/campanhas" element={<PainelCampanhas />} />
            <Route path="/campanhas/nova" element={<EditarCampanha />} />
            <Route path="/campanhas/editar/:id" element={<EditarCampanha />} />
            <Route path="/expedicao" element={<Expedicao />} />
            <Route path="/inscritos" element={<InscritosCampanha />} />
            <Route path="/admin/todas-inscricoes" element={<InscritosTodasCampanhas />} />
            
            <Route path="/configuracoes/valor-do-ponto" element={<ConfiguracoesValorPonto />} />
            <Route path="/configuracoes/valor-por-km" element={<ConfiguracaoFrete />} />
            <Route path="/teste-frete" element={<ConfiguracaoFrete />} />
            <Route path="/faq-bot" element={<FaqBot />} />
            <Route path="/usuarios/:id/permissoes" element={<PermissoesUsuario />} />
            <Route path="/logs-recaptcha" element={<LogsRecaptcha />} />
            <Route path="/admin/eventos" element={<ListarEventosPage />} />
            <Route path="/admin/eventos/criar" element={<CriarEventoPage />} />
            <Route path="/admin/eventos/editar/:slug" element={<EditarEventoPage />} />
            <Route path="/admin/sorteios" element={<SorteiosAdminEventoPage />} />
            <Route path="/admin/sorteios/todos" element={<PainelTodosSorteiosPage />} />
            <Route path="/admin/importar-operacao" element={<ImportarOperacaoTikpag />} />
            <Route path="/admin/importar-pix" element={<ImportarPixTikpag />} />
            <Route path="/admin/pix" element={<PixAdminPage />} />
            <Route path="/admin/pix/contas-a-pagar" element={<PixContasAPagarPage />} />
            <Route path="/admin/banner-home" element={<BannerHomePage />} />
            <Route path="/categorias-premios" element={<CategoriasPremios />} />
            <Route path="/admin/sorteios-leads" element={<SorteiosLeadsLista />} />
            <Route path="/admin/sorteios-leads/novo" element={<SorteioLeadForm />} />
            <Route path="/admin/sorteios-leads/editar/:id" element={<SorteioLeadForm />} />
            <Route path="/admin/sorteios-leads/:id/leads" element={<SorteioLeadsAdmin />} />
            <Route path="/admin/sorteios-leads/:id/qrcode" element={<SorteioQRCodePage />} />

            <Route path="/admin/tikpag-experience" element={<TikpagExperienceDashboard />} />
            <Route path="/admin/tikpag-experience/campanhas" element={<TikpagExperienceCampanhas />} />
            <Route path="/admin/tikpag-experience/pins" element={<TikpagExperiencePins />} />
            <Route path="/admin/tikpag-experience/categorias" element={<TikpagExperienceCategorias />} />
            <Route path="/admin/tikpag-experience/experiencias" element={<TikpagExperienceExperiencias />} />
            <Route path="/admin/tikpag-experience/apuracoes" element={<TikpagExperienceApuracoes />} />
            <Route path="/admin/tikpag-experience/participantes" element={<TikpagExperienceParticipantes />} />
            <Route path="/admin/tikpag-experience/escolhas" element={<TikpagExperienceEscolhas />} />
            <Route path="/admin/tikpag-experience/pins-entregas" element={<TikpagExperiencePinsEntregas />} />
            <Route path="/admin/tikpag-experience/relatorios" element={<TikpagExperienceRelatorios />} />
            <Route path="/admin/tikpag-experience/auditoria" element={<TikpagExperienceAuditoria />} />

            <Route path="/admin/tikpag-bi" element={<TikpagBI />} />
            <Route path="/admin/tikpag-bi/imobiliaria/:cnpj" element={<TikpagBIImobiliaria />} />
            <Route path="/admin/tikpag-bi/crescimento" element={<TikpagBICrescimento />} />
            <Route path="/admin/tikpag-bi/queda" element={<TikpagBIQueda />} />
            

            <Route
                path="/admin/tikpag-diagnostico"
                element={<TikpagDiagnostico />}
              />

          </>
        )}

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
          </Routes>
  </>
);
}

export default AppRouter;